import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk for sending notifications
export const sendNotification = createAsyncThunk(
  'notifications/send',
  async ({ profile_id, notificationData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/Profile/${profile_id}/SendNotification/`,
        notificationData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 
        'Failed to send notification'
      );
    }
  }
);

// Initial state
const initialState = {
  isLoading: false,
  error: null,
  lastSentNotification: null
};

// Slice
const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    clearNotificationError: (state) => {
      state.error = null;
    },
    clearLastSentNotification: (state) => {
      state.lastSentNotification = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotification.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.lastSentNotification = action.payload;
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

// Export actions and reducer
export const { clearNotificationError, clearLastSentNotification } = notificationSlice.actions;
export default notificationSlice.reducer;